import { createSelector } from 'reselect';
import { NutritionSerializer, Nutrition, NutritionUiLogic } from 'fitbeat.gym-core';
import { getTimeZone} from 'react-native-localize';
import moment from 'moment';

const getShowMealSelectionOverview = (state) =>
  state.nutrition.showMealSelectionOverView;

const getMaximumMealPrepTime = (state) => state.nutrition.maximumMealPrepTime;

const getMeals = (state) => {
  const { mealOfDayOpenInModal, mealsForTimeOfDay } = state.nutrition;
  return mealsForTimeOfDay[mealOfDayOpenInModal];
};

const getMealPlan = (state) => {
    return state.nutrition.mealPlans;
};

export const showMealSelectionOverviewSlector = createSelector(
  [getShowMealSelectionOverview],
  (showMealSelectionOverview) => showMealSelectionOverview,
);

export const selectMinAndMaxPrepTimes = createSelector(
  [getMeals],
  (meals) => {
    const prepDurations = meals ? meals.map(({prepDuration}) => prepDuration) : null;
    return {
      maxPrepTime: prepDurations ? Math.max(...prepDurations) : null,
      minPrepTime: prepDurations ? Math.min(...prepDurations) : null,
    };
  },
);

export const  selectMiddlePointBetweenMaxMin = createSelector(
  [selectMinAndMaxPrepTimes],
  ({minPrepTime, maxPrepTime}) => {
    return Math.round((maxPrepTime - minPrepTime) / 2) + minPrepTime;
  },
);

export const selectAndSortMealAccordingToMaximumMealPrepTime = createSelector(
  [getMaximumMealPrepTime, getMeals, selectMinAndMaxPrepTimes],
  (maximumMealPrepTime, meals, {maxPrepTime, minPrepTime}) => {
    const maxThreshhold = maximumMealPrepTime ?? (maxPrepTime - minPrepTime) / 2;
    return meals
      ? meals
          .filter((meal) => meal.prepDuration <= maxThreshhold)
          .sort((a, b) => b.prepDuration - a.prepDuration)
      : [];
  },
);

export const selectSliderStartingPoint = createSelector(
  [getMaximumMealPrepTime, selectMinAndMaxPrepTimes],
  (defaultmaximumMealPrepTimeState, {maxPrepTime, minPrepTime}) => {
    return NutritionUiLogic.getMamimumMealPrepTimeSliderStartingPoint(defaultmaximumMealPrepTimeState,
      maxPrepTime, minPrepTime);
});

export const availableTimesSelector = createSelector(
  [getMeals],
  (allMeals) => {
    if (!allMeals) {
      return [5];
    }
    const availableTimes = [];
    for (const meal of allMeals) {
      if (availableTimes.findIndex((time) => time === meal.prepDuration) === -1) {
        availableTimes.push(meal.prepDuration);
      }
    }
    availableTimes.sort((a, b) => a - b);
    return availableTimes;
});


export const selectNextXMeals = createSelector([getMealPlan], (mealPlans) => {
  if (mealPlans) {
    const numberOfMelas = 5;
    const timeZone = getTimeZone();
    const currentDateMoment = moment(new Date()).tz(timeZone);
    const requireRating = false;
    const mealPlansSerialized = NutritionSerializer.serializeMealPlanWithMeals(mealPlans);
    return Nutrition.findNextXMeals(numberOfMelas, mealPlansSerialized, requireRating, currentDateMoment);
  }
  return [];
  });
